import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Store} from '@ngxs/store';
import {compareVersion, merge, SessionState} from '@myvf/core';
import {TealiumModel} from './tealium.model';
import {LoggerService} from '../../../core/common/logger.service';
import {WindowService} from '../../../core/common/window.service';
import {TealiumModule} from './tealium.module';
import {MD5} from 'crypto-js';

@Injectable({
  providedIn: TealiumModule
})
export class TealiumAnalyticsService {
  constructor(
    private logger: LoggerService,
    private router: Router,
    private store: Store,
    private window: WindowService
  ) {
  }

  /* eslint-disable */
  get params(): TealiumModel {
    const {
      device: {installationId, appVersion},
      customer: {username, email, isEnriched, type, userType},
      currentItem: {pbo, msisdn, userPlus, subscriptionType},
      accountInfo: {tealiumAccountInfo},
      userInfo: {tealiumUserInfo}
    } = this.store.selectSnapshot(SessionState);
    const sysEnv = this.window.isAndroid() || this.window.isiOS() ? 'Mobile' : 'Desktop';
    const businessSubType = userType?.toLowerCase() === 'chooser' ? 'AccountManager' : userPlus ? 'UserPlus' : 'EndUser';

    let accountProfileInfo: any;
    let userProfileInfo: any;

    const compare = compareVersion(appVersion, '6.10.0');

    // Check app version is > '6.10.0'
    if(compare >= 0){
      accountProfileInfo = tealiumAccountInfo?.profileInfo;
      userProfileInfo = tealiumUserInfo?.profileInfo;
    }
    else{
      // If app version < '6.10.0' profileInfo must be set in this way
      accountProfileInfo = {
        userName: username ? MD5(username).toString() : '',
        email: email ? MD5(email).toString() : '',
        persistentBO: pbo || '',
        profileID: msisdn ? MD5(msisdn).toString() : '',
        segment: 'CB',
        market: 'Business',
        businessType: type || '',
        businessSubType,
        gender: '',
        age: 0,
        status: isEnriched ? 'Enriched' : 'Logged in',
        subscriptionType: subscriptionType || '',
        postalCode: 0,
        accountManagerID: '',
        tenure: 1,
        dateOfBirth: '',
        paymentType: ''
      }

      userProfileInfo = {
        userName: username ? MD5(username).toString() : '',
        email: email ? MD5(email).toString() : '',
        persistentBO: pbo || '',
        profileID: msisdn ? MD5(msisdn).toString() : '',
        segment: 'CB',
        market: 'Business',
        businessType: type,
        businessSubType,
        gender: '',
        age: 0,
        status: isEnriched ? 'Enriched' : 'Logged in',
        subscriptionType: subscriptionType || '',
        postalCode: 0,
        accountManagerID: '',
        tenure: 1,
        dateOfBirth: '',
        paymentType: ''
      }
    }
    return {
      page: {
        pageInfo: {
          sysEnv,
          destinationURL: window.location.href,
          referringURL: document.referrer,
          variant: '0',
          version: appVersion || '',
          language: 'it-IT',
          geoRegion: 'IT',
          pageID: ''
        },
        category: {
          primaryCategory: 'Business'
        },
        attributes: {
          querystring: this.router.routerState.snapshot.root.queryParams,
          pageError: ''
        }
      },
      pageInstanceID: `${sysEnv} Change MSISDN - ${MD5(msisdn).toString()}`,
      account: {
        attributes: {
          deviceID: installationId || '',
          maxTenure: '3',
          minTenure: '1'
        },
        profileInfo: accountProfileInfo
      },
      user: {
        profileInfo: userProfileInfo
      }
    };
  }

  /**
   * Questo metodo conterrà il bridge con la libreria di Adobe
   */
  push(action: string, obj: TealiumModel): TealiumModel {
    const digitalData = merge([this.params, obj]) as TealiumModel;

    this.logger.group(`Tealium Tagging`, digitalData);

    // TODO fare meglio, legare tutta la direttiva direttamente a link e non click
    if (this.window.native['wa_gc']) {
      this.window.native['wa_gc'](digitalData, action === 'click' ? 'link' : action);
    }

    return digitalData;
  }
}
